import { setAnalytics, isDuplicatePageError } from '../../../thd-analytics-utils';
import {
  ACCOUNT,
  ACCOUNT_PROFILE,
  ACCOUNT_PROFILE_PAGE_TYPE,
  CLOSE_ACCOUNT_PAGE,
  SYSTEM,
  NOT_APPLICABLE
} from '../../../constants';

const CLOSE_ACCOUNT_PAGE_FORM = 'close account page form';

export function closeAccount() {
  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('close-account.page-load', () => {
    digitalData.page = {
      pageInfo: {
        pageName: CLOSE_ACCOUNT_PAGE,
        pageType: ACCOUNT_PROFILE_PAGE_TYPE
      },
      category: {
        primaryCategory: ACCOUNT,
        subCategory1: ACCOUNT_PROFILE,
        subCategory2: CLOSE_ACCOUNT_PAGE
      }
    };

    setAnalytics(digitalData);
  });

  // setPageErrorInfo (src/pages/CloseAccountPage.tsx)
  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('close-account.page-error', ({ output }) => {
    const {
      type = 'error',
      displayType = 'page',
      pageSection = '',
      message = '',
      code = ''
    } = output || {};

    const pageError = {
      type,
      displayType,
      pageSection,
      message,
      code
    };

    digitalData.page = digitalData.page || {};
    digitalData.page.error = digitalData.page.error || [];
    if (!isDuplicatePageError(digitalData, pageError)) {
      digitalData.page.error.push(pageError);
    }
  });

  // setCloseAccountPostPageLoadAPIErrorAnalytics (src/utils/close-account-page-analytics.ts)
  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('close-account.post-page-load-error', ({ output }) => {
    const message = output?.message || '';

    const pageError = {
      type: SYSTEM,
      displayType: 'page',
      pageSection: CLOSE_ACCOUNT_PAGE_FORM,
      message: `api error: ${message}`,
      code: NOT_APPLICABLE
    };

    digitalData.page = digitalData.page || {};
    digitalData.page.error = digitalData.page.error || [];
    if (!isDuplicatePageError(digitalData, pageError)) {
      digitalData.page.error.push(pageError);
    }
  });
}
